import axios from 'axios'
import qs from 'qs'
import global from '../api/global-config'

const service = axios.create({
  // process.env.NODE_ENV === 'development' 来判断是否开发环境
  // baseURL: 'https://www.easy-mock.com/mock/592501a391470c0ac1fab128',
  // baseURL : process.env.NODE_ENV === 'development' ? '/api/' : 'http://118.178.92.139:8080',
  // baseURL: global.baseURL,
  baseURL: global.baseUrl,
  timeout: 30000
})

service.interceptors.request.use(config => {
  // 是否为POST请求
  const flag = config.method === 'post' || config.method === 'POST'
  if (flag && config.data) {
    config.data = qs.stringify(config.data)
  }
  return config
}, error => {
  return Promise.reject(error)
})

service.interceptors.response.use(response => {
  if (response.data.code === 0) {
    return response.data
  } else {
    return Promise.reject(new Error(response.data.msg))
  }
}, error => {
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js